<template>
  <form onsubmit="return false;">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <GmapAutocomplete
            ref="address"
            placeholder="Entrer un adresse"
            class="form-control"
            @place_changed="setPlace"
          >
          </GmapAutocomplete>
        </div>
      </div>
    </div>
    <GmapMap
      :id="id"
      ref="input"
      :center="map"
      :zoom="5"
      map-type-id="roadmap"
      style="width: 100%; height: 400px;"
    >
      <GmapMarker
        :position="map"
        :clickable="true"
        :draggable="true"
        @dragend="update"
      />
    </GmapMap>
  </form>
</template>
<script>
export default {
  name: "volcan-input-googlemap",
  props: {
    map: Object,
  },
  data: function () {
    return {
      id: null,
    };
  },
  mounted() {
    this.$refs.address.$el.value = this.map.address;
    $(this.$refs.address.$el).change(() => {
      this.map.address = this.$refs.address.$el.value;
    });
    this.id = "input" + this._uid;
  },
  methods: {
    update(e) {
      this.map.lat = e.latLng.lat();
      this.map.lng = e.latLng.lng();
    },
    setPlace(place) {
      this.map.address = this.$refs.address.$el.value;
      this.map.lat = place.geometry.location.lat();
      this.map.lng = place.geometry.location.lng();
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-googlemap.vue